export default __webpack_public_path__ + "static/media/buck_async_int_mosfet.25788b58.svg";